import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDateConversionPipe } from './dynamic-date-conversion.pipe';


@NgModule({
  declarations: [DynamicDateConversionPipe],
  imports: [
    CommonModule
  ],
  exports: [DynamicDateConversionPipe]
})
export class DynamicDateConversionPipeModule {}
